import {scrollToElement,getHashVar} from "./Util";
import {initStickyBlocks} from "./StickyBlock";

function renderTabs(rootDom) {
    const $tabsRoot = $(rootDom);
    const $togglers = $tabsRoot.find('> .tabs-titles .js-tab-title');
    const $firstActive = $tabsRoot.find('> .tabs-titles .js-tab-title._active');
    /*const firstActiveIndex = $tabsRoot.find('> .tabs-titles .js-tab-title._active').attr('data-index');*/
    const $select = $tabsRoot.find('> .tabs-select .js-tabs-select');
    const $contents = $tabsRoot.find('> .js-tab-contents > .js-tab-content');
    let hash = getHashVar();
    let $tabActive = $togglers.filter('[id="' + hash + '"], [href="#' + hash + '"]');

    $togglers.each((index, el) => {

        $(el).data('index', index).attr('data-index', index);
        $contents.eq(index).data('index', index).attr('data-index', index);
        $select.find('option').eq(index).data('index', index).attr('data-index', index);

        let id = $(el).attr('id');
        $('[href="#' + id + '"]:not(.js-tab-title)').on('click', function (e) {
            const trueClick = e.originalEvent && e.originalEvent.type === 'click' && e.originalEvent.isTrusted;

            e.preventDefault();
            $(el).trigger('click', {trueClick: trueClick});
        });
    });

    $togglers.on('init', function (e) {
        let $currTab = $(this);

        if ($firstActive.length && !$tabActive.length) {
            $currTab =  $firstActive;
        }

        let currTabIndex = $currTab.data('index');

        showTab(currTabIndex, $currTab);

        e.preventDefault();
    });

    $togglers.on('click', function (e, data) {
        let $currTab = $(this);
        let $currTabsWrap = $currTab.closest('.js-tabs');
        let currTabIndex = $currTab.data('index');
        const trueClick = e.originalEvent && e.originalEvent.type === 'click' && e.originalEvent.isTrusted || (data && data.trueClick);

        showTab(currTabIndex);

        if (trueClick) {
            if (!$currTabsWrap.attr('data-noscrolltab')) {
                scrollToElement($currTabsWrap);
            }
			const hash = $currTab.attr('id') || $currTab.attr('href').replace('#', '');

			if (hash) {
				history.replaceState(null, null, '#' + hash);
			}
        }
        e.preventDefault();
    });

    $select.on('change', function (e) {
        let $currTabSelect = $(this);
        let currTabIndex = $currTabSelect.find('option:selected').data('index');
        const trueChange = e.originalEvent && e.originalEvent.type === 'change' && e.originalEvent.isTrusted;

        showTab(currTabIndex);

        let $currTab = $togglers.filter('._active');

        if ($currTab.attr('id') && trueChange) {
            scrollToElement($currTabSelect);
            history.replaceState(null, null, '#' + $currTab.attr('id'));
        }
    });

    if ($tabActive.length) {
        $tabActive.trigger('init');
        scrollToElement($tabActive);
    } else {
        // если в табах есть прилипающий блок, то делаем "хитрый" инит со второго таба, иначе не срабатывает прилипание
        if ($tabsRoot.find('.js-sticky').length) {
            initTabWithStickyBlock($togglers);
        } else if (App.H.is('.ios')) {
            if (!(!$tabActive.length && $tabsRoot.hasClass('js-tabs-thumbs') && $('.js-tabs-thumbs').data('start'))) {
                initTabIos($togglers);
            }
        } else {
            $togglers.eq(0).trigger('init');
        }
    }

    function showTab(index) {
        $togglers.removeClass('_active');
        $contents.removeClass('_active');
        $togglers.filter(`[data-index="${index}"]`).addClass('_active').removeClass('_disabled');
        $contents.filter(`[data-index="${index}"]`).addClass('_active');
        $select.find(`option[data-index="${index}"]`).prop('selected', true);

        let currHeight = $contents.filter('._active').outerHeight();

        $tabsRoot.find('> .js-tab-contents').css({
            'min-height': `${currHeight}px`
        });

        // проскролливание табов до активного пункта
        let $currTab = $togglers.filter(`[data-index="${index}"]`);
        if ($currTab.length > 0 && $currTab.closest('.tabs-titles--scroll').length > 0) {
            let currTabRight = $currTab.offset().left + $currTab.innerWidth();
            let $tabsContainer = $currTab.closest('.tabs-titles--scroll');
            let tabsRight = $tabsContainer.offset().left + $tabsContainer.innerWidth();
            let tabsScrollLeft = $tabsContainer.scrollLeft();

            if (currTabRight > tabsRight - tabsScrollLeft) {
                let diff = currTabRight - (tabsRight - tabsScrollLeft);
                $tabsContainer.scrollLeft(diff + 20);
            }
        }

        if (App.H.is('.ios')) {
            setTimeout(function () {
                $tabsRoot.find('> .js-tab-contents').css({
                    'min-height': `${currHeight}px`
                });
            }, 2000);
        }

        $contents.filter('._active').trigger('tabContentShow');

        $contents.each(function(ind, item) {
            if ($(item).find('video, iframe').length) {
                $(item).find('video, iframe').each(function(i, video) {
                    if (video.tagName.toLowerCase() === 'video') {
                        video.pause();
                    } else {
                        const src = video.src;
                        video.src = src;
                    }
                });
            }
        });

        requestAnimationFrame(function() {
            const $swiper = $tabsRoot.closest('.swiper-container');

            if ($swiper.length && $swiper[0].swiper) {
                $swiper[0].swiper.updateAutoHeight(300);
            }
        });
    }

    function initTabWithStickyBlock($tabTogglers) {
        setTimeout(function () {
            $tabTogglers.eq(1).trigger('click');
            if ($('.js-sticky').length) {
                initStickyBlocks();
            }
            $tabTogglers.eq(0).trigger('init');
        }, 500);
    }

    function initTabIos($tabTogglers) {
        $tabTogglers.eq(1).trigger('click');

        setTimeout(function () {
            $tabTogglers.eq(0).trigger('init');
        }, 500);
    }

    if ($tabsRoot.find('.tabs-titles--scroll-desktop').length) {
        let $tabsContainer = $tabsRoot.find('.tabs-titles--scroll');
        let $tabsPrev = $tabsContainer.siblings('.js-tabs-prev');
        let $tabsNext = $tabsContainer.siblings('.js-tabs-next');
        let diff = App.mobile || App.W.outerWidth() < 768 ? 148 : 218;

        $tabsPrev.on('click', function() {
            $tabsContainer.scrollLeft($tabsContainer.scrollLeft() - diff);
        });

        $tabsNext.on('click', function() {
            $tabsContainer.scrollLeft($tabsContainer.scrollLeft() + diff);
        });
    }

    rootDom.rendered = true;

    if (!$tabActive.length && $tabsRoot.hasClass('js-tabs-thumbs') && $('.js-tabs-thumbs').data('start')) {
        let startFrom = $('.js-tabs-thumbs').data('start') - 1;

        showTab(startFrom);
    }
}

$('.js-tabs').each((i, tabs) => {
    renderTabs(tabs);
});

App.D.on('click', '.js-open-tab-link', function (e) {
    const tabName = $(this).data('tab-name');
    let $currTab = $(`.js-tab-title[data-name="${tabName}"]`);
    if (!$currTab.length) {
        $currTab = $(`.js-tab-title#${tabName}`);
    }

    $currTab.trigger('click');
    scrollToElement($currTab);

    e.preventDefault();
});

/* при смене ориентации устройства пересчитываем высоту активного таба */
App.W.on('orientationchange load resize', function() {
    setTimeout(function () {
        $('.js-tabs').each(function () {
            actualizeTabHeight($(this));
        });
    }, 500);
});

App.W.on('actualizeTabHeight', function() {
    $('.js-tabs').each(function () {
        actualizeTabHeight($(this));
    });
});

App.W.on('renderTabs', function() {
    $('.js-tabs').each(function () {
        if (!this.rendered) {
            renderTabs(this);
        }
    });
});

export function actualizeTabHeight($tab) {
    const currHeight = $tab.find('.js-tab-content._active').outerHeight();

    $tab.find('.js-tab-contents').css({
        'min-height': `${currHeight}px`
    });
}
